export default __webpack_public_path__ + "static/media/settings.1bedb289.svg";